import React from 'react';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExitWithoutSaving: () => void;
  onSaveAndExit: () => void;
  isLoading?: boolean;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  isOpen,
  onClose,
  onExitWithoutSaving,
  onSaveAndExit,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <div className="d-flex align-items-center">
              <div 
                className="rounded-circle d-flex align-items-center justify-content-center me-3"
                style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: '#ffc107',
                  color: 'white'
                }}
              >
                <i className="fas fa-exclamation-triangle fa-lg"></i>
              </div>
              <h5 className="modal-title mb-0" style={{ color: '#ffc107', fontWeight: '600' }}>
                Alterações Não Salvas
              </h5>
            </div>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
              disabled={isLoading}
            ></button>
          </div>
          
          <div className="modal-body pt-2">
            <div className="alert alert-warning border-0" style={{ backgroundColor: '#fff3cd' }}>
              <div className="d-flex align-items-start">
                <i className="fas fa-info-circle text-warning me-2 mt-1"></i>
                <div>
                  <strong>Atenção</strong>
                  <p className="mb-0 mt-1 text-muted">
                    Você possui alterações não salvas que serão perdidas se sair desta tela.
                  </p>
                </div>
              </div>
            </div>
            
            <p className="mb-3" style={{ fontSize: '1.1rem', lineHeight: '1.5' }}>
              Você fez alterações na grade que ainda não foram salvas. Sair desta tela fará com que essas alterações sejam perdidas.
            </p>
            
            <p className="mb-0 text-muted">
              O que você gostaria de fazer?
            </p>
          </div>
          
          <div className="modal-footer border-0 pt-0">
            <button 
              type="button" 
              className="btn btn-secondary me-2"
              onClick={onClose}
              disabled={isLoading}
            >
              <i className="fas fa-times me-2"></i>
              Cancelar
            </button>
            <button 
              type="button" 
              className="btn btn-outline-danger me-2"
              onClick={onExitWithoutSaving}
              disabled={isLoading}
            >
              <i className="fas fa-sign-out-alt me-2"></i>
              Sair sem Salvar
            </button>
            <button 
              type="button" 
              className="btn btn-success"
              onClick={onSaveAndExit}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Salvando...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-2"></i>
                  Salvar e Sair
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;